import moment from 'moment-timezone';
export const filterScreenshotsByTimeRange = (
  screenshots,
  segmentStart,
  segmentEnd,
  timezone
) => {
  if (!segmentStart || !segmentEnd) {
    return screenshots; // No filtering if no time range provided
  }

  const segmentStartMoment = moment(segmentStart).tz(timezone);
  const segmentEndMoment = moment(segmentEnd).tz(timezone);

  return screenshots.filter((screenshot) => {
    if (!screenshot.timestamp) return false;
    const screenshotMoment = moment(screenshot.timestamp).tz(timezone);
    // Include screenshots that are >= segmentStart and <= segmentEnd
    // This includes screenshots at the exact end time
    return (
      screenshotMoment.isSameOrAfter(segmentStartMoment) &&
      screenshotMoment.isSameOrBefore(segmentEndMoment)
    );
  });
};
